import api from "./index";

import cookiesHelper from "../helpers/cookies";

import { ISaveComponent } from "../interfaces/services";

export const saveComponent = async (data: ISaveComponent) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`components`, data);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};

export const deleteComponent = async (id: number) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`components/${id}`);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};